import { Box, Divider, Text, VStack } from '@bonusly/design-system';
import { useCurrentCompany, useIsBonuslyCompany } from '@bonusly/who-am-i';

import { GranolaConnectCard } from '../../../../components/granola/granola-connect-card';
import { LinearConnectCard } from '../../../../components/linear/linear-connect-card';

export const ConnectorsSection = () => {
	const company = useCurrentCompany();
	const isBonuslyCompany = useIsBonuslyCompany();

	if (!isBonuslyCompany) return null;

	const hasGranola = company?.bizy_connectors_granola;
	const hasLinear = company?.bizy_connectors_linear;

	if (!hasGranola && !hasLinear) return null;

	return (
		<>
			<Divider />
			<Box>
				<Text fontSize="sm" fontWeight="semibold" color="text.default" mb={3}>
					Connectors
				</Text>
				<Text fontSize="xs" color="text.softer" mb={3}>
					Connect external tools so Bizy can access your data.
				</Text>
				<VStack spacing={2} align="stretch">
					{hasGranola && <GranolaConnectCard />}
					{hasLinear && <LinearConnectCard />}
				</VStack>
			</Box>
		</>
	);
};
